import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { CSSProperties } from "react";

export const container: CSSProperties = {
  fontSize: 14,
  color: greys.darkGreyBlue,
  overflow: "hidden",
};

export const loadingContainer: CSSProperties = {
  ...container,
  paddingTop: 10,
  paddingBottom: 10,
  color: greys.cloudyBlue,
  fontStyle: "italic",
};

export const stat: CSSProperties = {
  fontWeight: 600,
};

export const profileCosts: CSSProperties = {
  overflow: "hidden",
  marginTop: 10,
  marginBottom: 10,
  height: 38,
  position: "relative",
};

export const profileCostsAbsolute: CSSProperties = {
  position: "absolute",
  display: "flex",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
};

export const tooltipIcon: CSSProperties = {
  color: greys[3],
};

export const avatarContainer: CSSProperties = {
  marginRight: 10,
};

export const uncrawledAvatar: CSSProperties = {
  background: greys[2],
};

export const responseText: CSSProperties = {
  fontSize: "12px",
  marginTop: 4,
  color: greys.slate,
};

export const remainder: CSSProperties = {
  overflow: "hidden",
  flexShrink: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  fontWeight: 600,
  backgroundColor: greys.blueGrey,
};

export const rowsContainer: CSSProperties = {
  marginTop: 10,
};

export const expandToggle: CSSProperties = {
  cursor: "pointer",
  color: colors.blueCool.standard,
  fontWeight: 700,
};

export const row: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  marginBottom: 10,
  alignItems: "center",
};

export const rowText: CSSProperties = {
  fontSize: 14,
  marginLeft: 10,
};

export const nameText: CSSProperties = {
  maxWidth: "212px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};

export const rowOthers: CSSProperties = {
  marginBottom: 10,
};

export const rowAdditionalText: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontSize: 12,
  lineHeight: "16px",
  color: greys.slate,
};

export const rowAdditionalWarningText: CSSProperties = {
  ...rowAdditionalText,
  color: colors.peach.darker,
};

export const rowIcon: CSSProperties = {
  height: 18,
  width: 18,
  marginRight: 4,
};
